<h2 mat-dialog-title>Solicitação de mudança no horário</h2>
<mat-dialog-content class="mat-typography" *ngIf="currentUser.type == 'practitioner' || currentUser.type == 'organization'">
  <div class="requestInfos">
    <b>Nome da organização:</b> {{ affiliation.subject.display }} <br />
    <b>Tipo de solicitação:</b> Alteração no horário <br />
    <div *ngIf="currentAffiliation?.specialty"><b>Nome da especialidade:</b> {{ getSpecialtyName() }} <br /></div>
    <b>Data da solicitação:</b> {{ layout.dateFormat(changeHoursRequest.requestedDate) }} <br />
    <b>Status da solicitação:</b> {{ transformStatusText(changeHoursRequest.status) }} <br />
  </div>

  <div class="changeHoursComparison">
    <div class="col-12 col-md-6">
      <mat-card>
        <h2>Horário Atual</h2>
        <ng-container *ngIf="hasDefinedHours; else noHours">
          <ng-container *ngFor="let day of unchangedHours">
            <div *ngIf="day.active && day.hours?.length">
              <b>{{ day.dia }}:</b>
              <div *ngFor="let hour of day.hours">{{ hour.startHour }} - {{ hour.endHour }}</div>
            </div>
          </ng-container>
        </ng-container>

        <ng-template #noHours>
          <div>Horário não definido.</div>
        </ng-template>
      </mat-card>
    </div>

    <div class="col-12 col-md-6">
      <mat-card>
        <h2>Horário Solicitado</h2>
        <ng-container *ngFor="let day of changeHoursRequest.practitionerHours">
          <div *ngIf="day.active">
            <b>{{ day.dia }}:</b>
            <div *ngFor="let hour of day.hours">{{ hour.startHour }} - {{ hour.endHour }}</div>
          </div>
        </ng-container>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <div *ngIf="currentUser.type == 'organization'">
    <button mat-flat-button color="success" *ngIf="changeHoursRequest.status == 'pending'" (click)="approveRequest()">Aprovar</button>
    <button mat-flat-button color="warn" *ngIf="changeHoursRequest.status == 'pending'" (click)="cancelRequest()">Recusar</button>
  </div>
</mat-dialog-actions>
